import type { ResolvedChatConfig, Transport } from '../types';
import { sseTransport } from './sse';
import { ndjsonTransport, textStreamTransport } from './stream';
import { jsonTransport } from './json';
import { openaiTransport } from './openai';

export { sseTransport } from './sse';
export { ndjsonTransport, textStreamTransport } from './stream';
export { jsonTransport } from './json';
export { openaiTransport } from './openai';
export { buildPayload, readLines, extractText, postChat, describeHttpError } from './http';

const registry: Record<ResolvedChatConfig['protocol'], Transport> = {
  sse: sseTransport,
  ndjson: ndjsonTransport,
  text: textStreamTransport,
  json: jsonTransport,
  openai: openaiTransport,
};

/** `config.transport` wins; otherwise the protocol picks a built-in. */
export function resolveTransport(config: ResolvedChatConfig): Transport {
  if (config.transport) return config.transport;
  const transport = registry[config.protocol];
  if (!transport) {
    throw new Error(
      `Unknown protocol "${config.protocol}". Use one of: ${Object.keys(registry).join(', ')}, or pass a custom transport.`,
    );
  }
  return transport;
}
